import DOMElement from "../../dom-element";

export const FIELD_TYPES = [
  'text',
  'email',
  'tel',
  'radio',
  'checkbox',
  'select',
  'payment-format'
];

export default class FormFieldElement extends DOMElement {
    constructor(props = {}) {
        super('div', props);
    }

    _setProps() {
        super._setProps();

        this.props.text = null;
        this.props.html = null;
        this.props.children = null;

        this.id = this.props.id;
        this.name = this.props.name;
        this.labelElement = this.props.labelElement;
        this.contentElement = this.props.contentElement;

        this.type = this.props.type != null && FIELD_TYPES.includes(this.props.type) ? this.props.type : 'text';
        this.inputId = this.props.inputId;
        this.inputClass = this.props.inputClass;
        this.required = this.props.required === true;
        this.disabled = this.props.disabled === true;
        this.pattern = this.props.pattern;
        this.cacheable = this.props.cacheable === true;
        this.unsendable = this.props.unsendable === true;
        this.label = this.props.label;
        this.labelTag = this.props.labelTag || 'label';
        this.instructions = this.props.instructions;
        this.errorText = this.props.errorText;
        this.theme = this.props.theme || 'default';
    }

    _checkProps() {
        super._checkProps();

        if (!this.id) {
            throw new Error('FormFieldElement: ID is not defined.');
        }

        if (!this.name) {
            throw new Error('FormFieldElement: Name is not defined.');
        }

        if (!FIELD_TYPES.includes(this.type)) {
            throw new Error('FormFieldElement: Wrong field type.');
        }

        if (this.labelElement && !(this.labelElement instanceof DOMElement)) {
            throw new Error('FormFieldElement: Label element should be an instance of DOMElement.');
        }
    }

    _initInput() {
        this.input = this.input || this.props.input;

        if (!this.input) {
            throw new Error('FormFieldElement: Input is not defined.');
        }

        if (!(this.input instanceof DOMElement)) {
            throw new Error('FormFieldElement: Input should be an instance of DOMElement.');
        }
    }

    _initProps() {
        super._initProps();
        this._initInput();

        this.attributes = Object.assign({
            id: this.id,
            'data-form': 'field',
            'data-name': this.name,
            'data-type': this.type,
        }, this.attributes);

        this.attributes.class = DOMElement.classListFrom(
            ['f-field', `-${this.theme}`],
            this.attributes.class);

        if (this.required) {
            this.attributes['data-required'] = 'true';
        }

        if (this.disabled) {
            this.attributes['data-disabled'] = 'true';
        }

        if (this.cacheable) {
            this.attributes['data-cacheable'] = 'true';
        }

        if (this.unsendable) {
            this.attributes['data-unsendable'] = 'true';
        }

        if (this.pattern) {
            this.attributes['data-pattern'] = this.pattern;
        }

        if (!this.labelElement && this.label) {
            const labelAttributes = {
                class: 'f-field-label f-field_label'
            };

            if (this.inputId && this.labelTag === 'label') {
                labelAttributes.for = this.inputId;
            }

            this.labelElement = new DOMElement(this.labelTag, {
                text: this.label,
                attributes: labelAttributes,
            });
        }

        this.children = [
            new DOMElement('div', {
                class: 'f-field-container',
                children: [
                    ...(this.labelElement ? [this.labelElement] : []),
                    new DOMElement('div', {
                        class: 'f-field-input f-field_input',
                        child: this.input
                    })
                ]
            }),
            ...(this.contentElement ? [this.contentElement] : []),
            ...(this.instructions ? [new DOMElement('p', {
                class: 'f-field-instructions f-field_instructions',
                html: this.instructions
            })] : []),
            ...(this.errorText ? [new DOMElement('p', {
                class: 'f-field-error f-field_error',
                attributes: { 'data-form': 'field-error' },
                html: this.errorText
            })] : [])
        ];
    }
}